import coreBoxWithEdit from "./coreBoxWithEdit.vue";
export default coreBoxWithEdit;
